// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $("#arriveInput").attr("value");
var end = $("#departureInput").attr("value");
var opencheck = 0;
var firstClick = 0;

(function () {
  if (!window.ActiveXObject && "ActiveXObject" in window) {
    //is explorer
    function msieversion() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        const image_fit = document.getElementsByClassName("image-fit__wrapper");
        for (let i = 0; i < image_fit.length; i++) {
          const this_image = image_fit[i].getElementsByTagName("img")[0];
          const image_data = this_image.dataset.srcset;
          const image_src = this_image.getAttribute("src");
          image_fit[i].classList.add("ie-bg");
          if (image_data) {
            image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
          } else {
            image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
          }
        }
      } else {
        console.log("other browser");
      }

      return false;
    }

    msieversion();
  } else {
    /*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
    var scrollParallax = [];
    var scrolled = 0;

    // screen height
    var v_height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    function doParallax(elm) {
      let boundes = elm.dataset.parallax.split(","); // get it from html
      //get distance in positive value
      let distance = Math.abs(boundes[0] - boundes[1]);
      if (boundes[0] > boundes[1]) {
        //get distance in negative value (to do the scroll inverse)
        distance = distance * -1;
      }
      //Equivalent distance using screen height + element height
      const unit_scroll = distance / (v_height + elm.offsetHeight);
      let temp = 0;

      let topElement = 0;
      let element = elm;

      let id_elem = elm.dataset.parallaxid;

      do {
        topElement += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);

      let parallaxFunction = function () {
        //Obtain the distance between top screen and document top 0
        scrolled = document.documentElement.scrollTop || window.pageYOffset;
        //Distance of bottom page to top of the element
        let relative_distance = scrolled + v_height - topElement;
        //transpoling data to move the parallax element relative to the scroll of all the screen
        temp = unit_scroll * relative_distance + parseInt(boundes[0]);
        //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
        elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
      };

      scrollParallax[id_elem] = parallaxFunction;

      window.addEventListener("scroll", scrollParallax[id_elem]);
    }

    let observers_parallax = document.querySelectorAll(".js-parallax-element");

    if (observers_parallax) {
      let options_parallax = {
        root: null, // relative to document viewport
        rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0, // visible amount of item shown in relation to root
      };

      function handler_parallax(entries, observer) {
        let entry;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            doParallax(entry.target);
          } else {
            let id_elem = entry.target.dataset.parallaxid;
            window.removeEventListener("scroll", scrollParallax[id_elem]);
          }
        });
      }

      let observable_parallax = new IntersectionObserver(
        handler_parallax,
        options_parallax
      );
      let counter = 1;
      observers_parallax.forEach(function (element) {
        observable_parallax.observe(element);
        element.dataset.parallaxid = counter;
        counter++;
      });
    }
    /********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
  }

  $(".form-module-wrapper form").addClass("animate-fade top");
  $(".text-modules-wrapper .text-modules").addClass("animate-fade top");

  let BurgerMenu = document.getElementById("js_btn_menu");
  let NavigationBox = document.getElementById("navigationBox");
  let Body = document.body;
  let Header = document.getElementById("header");

  if (BurgerMenu) {
    BurgerMenu.addEventListener("click", function (e) {
      e.preventDefault();
      if (this.classList.contains("open")) {
        this.classList.remove("open");
        this.querySelector(".text").textContent = "Menu";
        NavigationBox.classList.remove("open");
        Body.classList.remove("scroll-no");
        Header.classList.remove("open");
      } else {
        this.classList.add("open");
        this.querySelector(".text").textContent = "Close";
        NavigationBox.classList.add("open");
        Body.classList.add("scroll-no");
        Header.classList.add("open");
      }
    });
  }

  let BtnBook = document.getElementById("js_btn_book");
  let BookingBox = document.getElementById("bookBox");
  let BookClose = document.getElementById("js_book_close");

  if (BtnBook) {
    BtnBook.addEventListener("click", function (e) {
      e.preventDefault();
      BookingBox.classList.add("open");
      Body.classList.add("scroll-no");
    });
  }

  if (BookClose) {
    BookClose.addEventListener("click", function (e) {
      e.preventDefault();
      BookingBox.classList.remove("open");
      Body.classList.remove("scroll-no");
    });
  }
  $("#primary-nav li").children("ul").parent("li").addClass("arrow");
  $(document).ready(function () {
    // Main Nav Dropdown
    $('#primary-nav li').off('click').on('click', function(event) {
      var $arrow = $(event.target).closest('li');
      if ($arrow.hasClass('arrow-clicked')) {
          $arrow.removeClass('arrow-clicked');
          $("ul.submenu", this).fadeOut(300);
      } else {
          $arrow.addClass('arrow-clicked');
          $("ul.submenu", this).fadeIn(300);
      }
    });

    $("#arriveInput, #arriveInputHome").on("change", function () {
      start = $(this).val();
      $(".calendar-home, .calendar-block").datepicker("setDate", start);
      $(this).attr("value", start);
    });

    $("#departureInput, #departureInputHome").on("change", function () {
      end = $(this).val();
      $(".calendar-home, .calendar-block").datepicker("setDate", end);
      $(this).attr("value", end);
    });

    $("#arrive_depart_home").click(function () {
      if ($("#fakeInput").hasClass("active")) {
        $("#fakeInput").removeClass("active");
        $("#fakeInput").fadeOut();
      } else {
        $("#fakeInput").addClass("active");
        $("#fakeInput").fadeIn();
      }
    });

    $("#closeFake, #adults_home").click(function () {
      $("#fakeInput").fadeOut();
    });

    $(".calendar-block, .calendar-home").datepicker({
      changeMonth: false,
      dateFormat: "yy-mm-dd",
      numberOfMonths: 1,
      beforeShowDay: function (date) {

        setTimeout(function() {
					document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
						e.setAttribute('tabindex', '-1');
					})
				}, 1000);
        
        $.datepicker._defaults.dateFormat = "yy-mm-dd";
        //console.log(date,date.getTime(),start,end);
        let startDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        let endDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        if (date.getTime() == startDate.getTime()) {
          return [true, "startday"];
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, "endday"];
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, "days"];
            } else {
              return [true, ""];
            }
          }
        }
      },
      onSelect: function (date) {
        let arrive = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        let departure = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        let selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date
        );

        if (opened == 0) {
          opened = 1;
          start = date;
          end = date;
          opencheck = 0;
        } else {
          opened = 0;
          if (selectedDate <= arrive) {
            end = start;
            start = date;
          } else {
            end = date;
          }
          $("#fakeInput").fadeOut();
          opencheck = 1;
          firstClick = 0;
        }

        $("#arriveInput, #arriveInputHome").attr("value", start);
        $("#departureInput, #departureInputHome").attr("value", end);
        $("#arrive_depart, #arrive_depart_home").attr(
          "value",
          start + " - " + end
        );
      },
      onChangeMonthYear: function () {
        opencheck = 1;
      },
    });

    $("input[name=zip_code]").attr("maxlength", "5");

    // ID logo remove
    let logosId = document.querySelectorAll(".logo svg");
    for (let i = 0; i < logosId.length; i++) {
      let item = logosId[i];
      item.removeAttribute("id");
      item.firstElementChild.removeAttribute("id");
    }

    let elementSpecials = document.querySelectorAll(".specials-rate");
    let elementSpecialsInput = document.querySelectorAll(".inline-promo");

    elementSpecials.forEach((element) => {
      let inputPrevius = element.previousElementSibling;
      if (inputPrevius === null) return;

      let idInput = inputPrevius.getAttribute("id");
      let inputToChange = "inline-promo, promo";

      if (inputToChange.indexOf(idInput) !== -1) {
        element.addEventListener("change", function (event) {
          let target = event.target;
          target && inputPrevius.setAttribute("name", target.value);

          // set maxlenght
          if (target.value === "corporateCode") {
            inputPrevius.setAttribute("maxlength", "10");
          } else if (target.value === "promoCode"){
            if ( document.querySelector('body.site-2028') ) {
              inputPrevius.setAttribute("maxlength", "10");
            } else {
              inputPrevius.setAttribute("maxlength", "6");
            }
          } else {
            inputPrevius.setAttribute("maxlength", "6");
          }

          // validation is error
          let boxError = target.nextElementSibling;
          if (inputPrevius.value !== "" && target.value !== "") {
            boxError =
              boxError !== null ? boxError.classList.remove("error") : null;
          } else if (inputPrevius.value !== "" && target.value === "") {
            boxError =
              boxError !== null ? boxError.classList.add("error") : null;
          }
        });
      }
    });

    elementSpecialsInput.forEach((element) => {
      let selectNext = element.nextElementSibling;
      if (selectNext === null) return;

      let idSelect = selectNext.getAttribute("id");
      let selectToChange = "inline-specials-rate, specials-rate";

      if (selectToChange.indexOf(idSelect) !== -1) {
        element.addEventListener("focus", function (event) {
          let target = event.target;
          let boxError = selectNext.nextElementSibling;

          if (target && selectNext.value === "") {
            boxError =
              boxError !== null ? boxError.classList.add("error") : null;
          } else {
            boxError =
              boxError !== null ? boxError.classList.remove("error") : null;
          }
        });

        element.addEventListener("blur", function (event) {
          let target = event.target;
          let boxError = selectNext.nextElementSibling;

          if (target.value === "" && selectNext.value === "") {
            boxError =
              boxError !== null ? boxError.classList.remove("error") : null;
          }
        });
      }
    });

    // onEventsBooking();
  });

  window.onload = function () {
    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };

  /*setTimeout( () => {
    document.querySelector( "#chatWithUsToggleContainer" ).style = "left: 80% !important"
  }, 1000 );*/
  
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  let content = document.getElementById("content");
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  if (content) {
    if (content.getElementsByClassName("sub-menu")[0]) {
      if (st > 370) {
        document
          .getElementById("content")
          .getElementsByClassName("sub-menu")[0]
          .classList.add("floating-up");
      } else {
        document
          .getElementById("content")
          .getElementsByClassName("sub-menu")[0]
          .classList.remove("floating-up");
      }
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
